import { useState, useCallback, useEffect } from 'react';

const useToast = (initialMessage = '', autoDismissDuration = 5000) => {
  const [toastMessage, setToastMessage] = useState(initialMessage);
  const [toastVisible, setToastVisible] = useState(false);

  const showToast = useCallback((message) => {
    setToastMessage(message);
    setToastVisible(true);
  }, []);

  const hideToast = useCallback(() => {
    setToastVisible(false);
    // Clear message after animation if needed
    setTimeout(() => setToastMessage(''), 300);
  }, []);

  const clearToast = useCallback(() => {
    setToastMessage('');
    setToastVisible(false);
  }, []);

  // Auto-dismiss timer
  useEffect(() => {
    let timer;
    if (toastVisible && autoDismissDuration > 0) {
      timer = setTimeout(() => {
        hideToast();
      }, autoDismissDuration);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [toastVisible, autoDismissDuration, hideToast]);

  return {
    toastMessage,
    toastVisible,
    showToast,
    hideToast,
    clearToast,
    setToastMessage,
  };
};

export default useToast;